import axiosInstance from '../../../fetchConfig/axiosConfig';
import logger from '../../../utils/logger';
import { idKey, normalizeCompId } from './compSheetLookup';

export function savedCompIds(rawComps) {
  if (!rawComps) return [];
  try {
    const comps = typeof rawComps === 'string' ? JSON.parse(rawComps) : rawComps;
    if (Array.isArray(comps)) return comps.map(normalizeCompId).filter(Boolean);
    if (comps && typeof comps === 'object') return Object.values(comps).map(normalizeCompId).filter(Boolean);
  } catch {
    if (typeof rawComps === 'string') return rawComps.split(/[,\s]+/).map(normalizeCompId).filter(Boolean);
  }
  return [];
}

/** Saved comp ids are already TransactionIDs (sales) or parcel ids (assessment). */
export async function fetchCompAddressById({ ids, reportType }) {
  const unique = [...new Set((ids || []).map(normalizeCompId).filter(Boolean))];
  if (!unique.length) return {};

  const idType = idKey(reportType) === 'parcel_id' ? 'PID' : 'TXN';
  try {
    const { data } = await axiosInstance.post('/lookup_property_address', {
      ids: unique,
      id_type: idType,
    });
    return data?.address_by_pid || {};
  } catch (e) {
    logger.error('fetchCompAddressById failed', e);
    return {};
  }
}
